import CourseCard from "./CourseCard"
import { CourseGridSkeleton } from "../skeletons"

export default function CourseGrid({ 
  courses = [],
  loading = false,
  showPrice = true
}) {
  if (loading) {
    return <CourseGridSkeleton count={8} />
  }

  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
      {courses.map((course, index) => (
        <CourseCard 
          key={course.id} 
          course={course} 
          index={index} 
          clickable={true} 
          showPrice={showPrice}
        />
      ))}
    </div>
  )
}